export default __webpack_public_path__ + "static/media/template22.e39bf5e4.svg";